import { message } from 'antd';

const defaultFailSolution = (res) => {
    if(typeof res !== 'object') {
        message.warn(res);
    }
};

const asyncFetch = (
    method,
    API,
    otherParams,
    success,
    otherHeader = {},
    corsSetting = 'same-origin',
    fail = defaultFailSolution,
    rawResp = false
) => {
    // const url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : 'http://124.223.194.210:8090';
    const url = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : '/api';
    let api = API;
    const requestMethod = String(method || 'GET').toUpperCase();
    const params = otherParams && typeof otherParams === 'object' ? otherParams : {};
    let init = {
        method: requestMethod,
        mode: corsSetting,
        credentials: 'include'
    };
    const notifyFail = (payload) => {
        if (typeof fail === 'function') {
            fail(payload);
        }
    };

    if (requestMethod === 'GET' || requestMethod === 'HEAD') {
        let urlSearch = [];
        for (let key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                urlSearch.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key] ?? ''))
            }
        }
        api += urlSearch.length === 0 ? '' : ('?' + urlSearch.join('&'))
    } else {
        init['headers'] = {
            'Content-Type': 'application/json;charset=utf-8;',
            ...otherHeader
        }
        init['body'] = JSON.stringify(params)
    }
    fetch(url + api, init).then(response => {
        if (rawResp) {
           success(response);
            return;
        }
        if (response.status !== 200) {
            response.text().then(text => {
                message.error({
                    content: text
                });
                notifyFail(text);
            });
            return;
        }
        try {
            response.json().then(res => {
                success(res ?? {})
            });
        } catch(err) {
            message.error({
                content: err.message
            })
            notifyFail(err);
        }
    }, (error) => {
        message.error({
            content: 'Error getting data, please refresh the page. ' + error
        })
        notifyFail(error);
    }).catch(function(err) {
        message.error({
            content: err.message
        });
        notifyFail(err);
    })
};

export default asyncFetch;
